/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-restricted-syntax */
import ReactDOM from 'react-dom';
import UserSmallHeader from 'components/Headers/UserSmallHeader';
import OrcamentoMaterial from 'models/OrcamentoMaterial';
import { ChangeEvent, Fragment, useEffect, useState } from 'react';
import {
  FaExclamationTriangle,
  FaFileExcel,
  FaPlus,
  FaPlusCircle,
  FaTrash,
} from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import {
  Badge,
  Button,
  Card,
  Col,
  Container,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from 'reactstrap';
import api from 'services/api';
import { Checkbox } from '@material-ui/core';
import Swal from 'sweetalert2';
import exportToSheet from 'utils/exportToSheet';
import toast from 'react-hot-toast';
import Orcamento from 'models/Orcamento';
import TagModel from 'models/Tag';
import OrcamentoMaterialModel from 'models/EngenhariaMaterial';
import FloatingButton from 'components/FloatingButton';
import { arredondaDecimais } from 'utils/arredondaDecimais';
import InputSelect from 'components/InputSelect';
import Produto from 'models/Produto';
import AutocompleteItemDomsge from 'components/AutocompleteItemDomsge';
import ItemDomsge from 'models/ItemDomsge';
import styled from 'styled-components';
import formatCurrency from 'utils/formatCurrency';
import ValidarAcessoPrograma from 'models/ValidarAcessoPrograma';
import traduzirProdutoAtividade from 'utils/traduzirProdutoAtividade';
import ConfiguracaoMaterialAvulso from './components/MaterialAvulso';

// Estilos
const ButtonsRightCol = styled(Col)`
  display: flex;
  justify-content: flex-center;
  align-items: center;
  margin-bottom: 1rem;
`;

const ColLabelItem = styled(Col)`
  display: flex;
  align-items: center;
`;

const LabelItem = styled(Label)`
  margin-bottom: 0;
  font-weight: 600;
`;

const MaterialListContainer = styled.div`
  margin-top: 1rem;
`;

const MaterialContainer = styled.div`
  margin-top: 1rem;
`;

const MaterialTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 0.875rem;
`;

const TableHeader = styled.thead`
  position: sticky;
  top: 0;
  z-index: 10;
`;

const TableBody = styled.tbody``;

const GroupHeaderRow = styled.tr`
  background-color: #2f75b6;
  color: #fff;

  td {
    padding: 10px;
    font-weight: bold;
    font-size: 14px;
  }
`;

const ColumnHeaderRow = styled.tr`
  background-color: #2f75b6;
  color: #fff;

  th {
    padding: 10px;
    font-size: 12px;
    text-align: center;
    vertical-align: middle;
    font-weight: normal;
  }
`;

const MaterialItemRow = styled.tr<{ isSubItem?: boolean }>`
  background-color: ${props => (props.isSubItem ? '#f8f9fa' : '#ffffff')};

  td {
    padding: 8px 10px;
    vertical-align: middle;
    border-bottom: 1px solid #dee2e6;
    ${props => props.isSubItem && 'font-style: italic;'}
  }
`;

const SubItemRow = styled.tr`
  background-color: #f8f9fa;
  font-style: italic;

  td {
    padding: 5px 10px;
    vertical-align: middle;
    border-bottom: 1px solid #dee2e6;
    font-size: 0.8rem;
  }
`;

interface LocationState {
  orcamentoId: number;
  acessoLimitado: {
    acessoLimitado: boolean;
    temAcesso: boolean;
  };
}

interface MaterialComposicaoSalvar {
  id: number | null;
  quantidade: number;
  quantidadeCalculada: number;
  quantidadeOriginal: number;
  atividade: number;
  sequenciaAtividade: number;
  posicaoEsquematica: string;
  fabrEmprCodigo: string;
  fabrCodigo: string;
  diteDgpeCodigo: string;
  diteCodigo: string;
  descricao: string;
  tipoItem: 'PR' | 'MP' | 'KI';
  indicaKit: 'S' | 'N';
  criadoManualmente: boolean | 'N';
  cicloVidaStatus: null | any;
  cicloVidaSubstituto: null | any;
  blocoFkCAD: null | any;
  aplicacao: string;
  nivel: number;
  agrupador: string;
  composicao: OrcamentoMaterialModel[];
  quantidadeProjetada: number;
  ordem: null | any;
  liberado: boolean;
  dadosEngenharia: null | any;
  ordemAgrupador: string | '';
  excluirMaterial: boolean;
  selecionado: boolean;
  quantidadeEditavel: number;
  disabled?: boolean;
}

const ConfiguracaoMateriais: React.FC = () => {
  const location = useLocation<LocationState>();
  const orcamentoId = location.state?.orcamentoId;
  const acessoLimitado = location.state?.acessoLimitado;

  const [orcamentoMateriais, setOrcamentoMateriais] = useState<
    OrcamentoMaterial[]
  >([]);
  const [orcamentoKits, setOrcamentoKits] = useState<OrcamentoMaterialModel[]>(
    [],
  );
  const [deletingMaterial, setDeletingMaterial] = useState(false);
  const [exibeBadge, setExibeBadge] = useState(false);
  const [orcamentos, setOrcamentos] = useState<Orcamento>({} as Orcamento);
  const [listaTodosMateriais, setListaTodosMateriais] = useState<any[]>([]);
  const [tags, settags] = useState<TagModel[]>([]);
  const [exibeKit, setExibeKit] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  const [materiaisAvulsosPlanilha, setMateriaisAvulsosPlanilha] = useState<
    OrcamentoMaterial[]
  >([]);
  const [itemDomsgeSelecionado, setItemDomsgeSelecionado] = useState<
    any | null
  >(null);
  const [quantidadeNovoItem, setQuantidadeNovoItem] = useState(1);
  const [produtos, setProdutos] = useState<Produto[]>([]);
  const [codEmpresa, setCodEmpresa] = useState('');

  const [kitCarregado, setKitCarregado] = useState(false);
  const [matCarregado, setMatCarregado] = useState(false);
  const [kitSelecionado, setKitSelecionado] = useState<any>(null);
  const [itensComposicao, setItensComposicao] = useState<
    MaterialComposicaoSalvar[]
  >([]);
  const [modalAdicionarItens, setModalAdicionarItens] = useState(false);
  const [agrupadorSelecionado, setAgrupadorSelecionado] = useState('Grupo');

  const [tiposExclusao, setTiposExclusao] = useState([]);
  const [deveRecarregarComp, setDeveRecarregarComp] = useState(true);

  const [acessoLimitadoCusto, setAcessoLimitadoCusto] = useState(
    {} as ValidarAcessoPrograma,
  );

  const [editingSequencia, setEditingSequencia] = useState<{
    atividade: number;
    sequencia: number;
  } | null>(null);
  const [tempTituloSequencia, setTempTituloSequencia] = useState('');

  const handleStartEditSequencia = (
    atividade: number,
    sequencia: number,
    currentTitle: string,
  ) => {
    console.log('entrou no handleStartEditSequencia', {
      atividade,
      sequencia,
      currentTitle,
    });
    setEditingSequencia({ atividade, sequencia });
    setTempTituloSequencia(currentTitle);
  };

  // const handleSaveSequenciaTitle = async () => {
  //   if (editingSequencia) {
  //     try {
  //       const response = await api.get(`/orcamento/material-titulo-sequencia`, {
  //         params: { ids, tempTituloSequencia },
  //       });

  //       setOrcamentoMateriais(prevMateriais =>
  //         prevMateriais.map(item => {
  //           if (
  //             item.produtoAtividadeId === editingSequencia.atividade &&
  //             item.sequenciaAtividade === editingSequencia.sequencia
  //           ) {
  //             return {
  //               ...item,
  //               tituloSequencia: tempTituloSequencia,
  //             };
  //           }
  //           return item;
  //         }),
  //       );
  //       setEditingSequencia(null);
  //       setTempTituloSequencia('');
  //     } catch (error) {
  //       setEditingSequencia(null);
  //       setTempTituloSequencia('');
  //       console.error('Erro ao salvar o título da sequência:', error);
  //       throw error;
  //     }
  //   }
  // };

  const handleSaveSequenciaTitle = async () => {
    if (editingSequencia) {
      Swal.fire({
        icon: 'info',
        text: `Atualizando título da sequência...`,
        allowOutsideClick: false,
        showConfirmButton: false,
      });
      try {
        const ids = orcamentoMateriais
          .filter(
            item =>
              item.produtoAtividadeId === editingSequencia.atividade &&
              item.sequenciaAtividade === editingSequencia.sequencia,
          )
          .map(item => item.id);

        const response = await api.post(
          `/orcamento/material-titulo-sequencia`,
          {
            ids,
            tituloSequencia: tempTituloSequencia,
          },
        );

        setOrcamentoMateriais(prevMateriais =>
          prevMateriais.map(item => {
            if (
              item.produtoAtividadeId === editingSequencia.atividade &&
              item.sequenciaAtividade === editingSequencia.sequencia
            ) {
              return {
                ...item,
                tituloSequencia: tempTituloSequencia,
              };
            }
            return item;
          }),
        );

        setEditingSequencia(null);
        setTempTituloSequencia('');

        toast.success('Título da sequência atualizado com sucesso!');
      } catch (error) {
        console.error('Erro ao salvar o título da sequência:', error);
        toast.error('Erro ao salvar o título da sequência');
      }
    }
    Swal.close();
  };

  const handleCancelEditSequencia = () => {
    setEditingSequencia(null);
    setTempTituloSequencia('');
  };

  async function getAcessoLimitadoPrograma() {
    const response = await api.get('/acesso-programa/acesso-programa', {
      params: {
        programaId: 127,
      },
    });
    setAcessoLimitadoCusto(response.data);
  }

  async function returnMateriais(): Promise<any[]> {
    const response = await api.get(`/orcamento/${orcamentoId}/material-avulso`);
    return response.data;
  }

  async function carregaOrcamentoMateriais(): Promise<OrcamentoMaterial[]> {
    const response = await api.get(`/orcamento/lista-materiais-novo`, {
      params: { orcamentoId },
    });

    const materiaisAvulsos = await returnMateriais();

    console.log(response.data);
    console.log(materiaisAvulsos);
    const todosMateriais = [
      ...response.data.filter(
        (item: OrcamentoMaterial) => item.criadoManualmente === false,
      ),
      ...materiaisAvulsos.map(avulso => ({
        ...avulso,
        criadoManualmente: true,
      })),
    ];

    setOrcamentoMateriais(todosMateriais);
    setMatCarregado(true);

    Swal.close();
    return todosMateriais;
  }

  async function carregaProdutos() {
    const response = await api.get(`/produto/configuracao/${orcamentoId}`);
    setProdutos(response.data);
    setCodEmpresa(response.data[0]?.codigoEmpresa);
  }

  function comparar(
    a: OrcamentoMaterialModel,
    b: OrcamentoMaterialModel,
  ): number {
    if (a.ordemAgrupador < b.ordemAgrupador) return -1;
    if (a.ordemAgrupador > b.ordemAgrupador) return 1;
    if (a.agrupador < b.agrupador) return -1;
    if (a.agrupador > b.agrupador) return 1;
    if (a.posicaoEsquematica && b.posicaoEsquematica) {
      const posicaoA = a.posicaoEsquematica;
      const posicaoB = b.posicaoEsquematica;
      if (Number(posicaoA) < Number(posicaoB)) return -1;
      if (Number(posicaoA) > Number(posicaoB)) return 1;
    }
    if (a.atividade < b.atividade) return -1;
    if (a.atividade > b.atividade) return 1;
    if (a.sequenciaAtividade < b.sequenciaAtividade) return -1;
    if (a.sequenciaAtividade > b.sequenciaAtividade) return 1;
    return 0;
  }

  function obterInfoSeq(str: string): any {
    if (str) {
      const partes: string[] = str.split('-');
      const pos: number = partes[1]?.indexOf('.');
      const posEsq: string = partes[1]?.substring(pos + 1);
      let grupo: string = partes[1]?.substring(0, pos);
      if (grupo?.length === 1) {
        grupo = `0${grupo}`;
      }
      return { grupo, posEsq };
    }

    return { grupo: 99, posEsq: 0 };
  }

  async function addItemComposicao() {
    if (!itemDomsgeSelecionado) {
      toast.error('Selecione um item material para inserir');
      return;
    }

    const materialEncontrado = listaTodosMateriais.find(
      material =>
        material.diteCodigo === itemDomsgeSelecionado.DITE_CODIGO &&
        material.diteDgpeCodigo === itemDomsgeSelecionado.DITE_DGPE_CODIGO &&
        material.fabrEmprCodigo === itemDomsgeSelecionado.FABR_EMPR_CODIGO &&
        material.fabrCodigo === itemDomsgeSelecionado.FABR_CODIGO,
    );

    if (!materialEncontrado) {
      return;
    }

    setItensComposicao(prev => [
      ...prev,
      {
        id: materialEncontrado.id,
        diteCodigo: materialEncontrado.diteCodigo,
        descricao: materialEncontrado.descricao,
        quantidade: quantidadeNovoItem,
        quantidadeCalculada: quantidadeNovoItem,
        quantidadeOriginal: quantidadeNovoItem,
        atividade: 0,
        sequenciaAtividade: 0,
        posicaoEsquematica: '',
        fabrEmprCodigo: '',
        fabrCodigo: '',
        diteDgpeCodigo: '',
        tipoItem: 'MP',
        indicaKit: 'N',
        criadoManualmente: true,
        cicloVidaStatus: null,
        cicloVidaSubstituto: null,
        blocoFkCAD: null,
        aplicacao: 'AVULSO',
        nivel: 0,
        agrupador: '',
        composicao: [],
        quantidadeProjetada: 0,
        ordem: null,
        liberado: false,
        dadosEngenharia: null,
        ordemAgrupador: '',
        excluirMaterial: false,
        selecionado: true,
        quantidadeEditavel: quantidadeNovoItem,
        disabled: false,
      },
    ]);

    setItemDomsgeSelecionado(null);
    setQuantidadeNovoItem(1);
    setResetKey(prev => prev + 1);
  }

  async function carregaOrcamentoKits(
    mostrarKit = false,
  ): Promise<OrcamentoMaterialModel[]> {
    // remover o integração no SAP
    const response = await api.get(
      `/material/material-composicao?configuracaoId=${orcamentoId}&carregarKit=${mostrarKit}`,
    );

    if (response.data) setOrcamentos(response.data as Orcamento);

    const listaItensort: OrcamentoMaterialModel[] = response?.data;

    for (let index = 0; index < listaItensort.length; index += 1) {
      if (!listaItensort[index].posicaoEsquematica) {
        const grupo = obterInfoSeq(listaItensort[index].aplicacao);
        listaItensort[index].agrupador = grupo.grupo;
        listaItensort[index].posicaoEsquematica = grupo.posEsq;
      }
    }

    if (listaItensort && listaItensort.length)
      setOrcamentoKits(listaItensort.sort(comparar));
    setKitCarregado(true);
    Swal.close();
    return response.data;
  }

  async function carregaOrcamento() {
    if (orcamentoId) {
      const response = await api.get(`/orcamento/${orcamentoId}`);
      if (response.data) setOrcamentos(response.data as Orcamento);
    }
  }

  async function carregaListaMateriais() {
    const response = await api.get(`/material/listAll`);
    setListaTodosMateriais(response.data);
  }

  async function listaTags() {
    const response = await api.get('/tag');
    settags(response.data);
  }

  async function getTiposExclusao() {
    const response = await api.get(`/tipo-exclusao/tipos`);
    setTiposExclusao(response.data);
  }

  // const recarregarLista = async () => {
  //   //setKitCarregado(false);
  //   // setMatCarregado(false);
  //   // carregaOrcamento();
  //   //carregaOrcamentoKits();
  //   // carregaOrcamentoMateriais();
  // };

  useEffect(() => {
    sessionStorage.setItem('TelaConfig', '');
  }, []);

  useEffect(() => {
    listaTags();
    getAcessoLimitadoPrograma();
  }, []);

  useEffect(() => {
    if (deveRecarregarComp) {
      carregaOrcamentoKits();
      carregaOrcamentoMateriais();
      setDeveRecarregarComp(false);
    }
  }, [deveRecarregarComp]);

  useEffect(() => {
    if (!kitCarregado || !matCarregado || !deveRecarregarComp) {
      Swal.fire({
        icon: 'info',
        text: `Buscando materiais...`,
        allowOutsideClick: false,
        showConfirmButton: false,
      });
    }
  }, [kitCarregado, matCarregado, deveRecarregarComp]);

  useEffect(() => {
    if (kitCarregado && matCarregado && deveRecarregarComp) {
      Swal.close();
    }
  }, [kitCarregado, matCarregado, deveRecarregarComp]);

  useEffect(() => {
    carregaOrcamento();
    carregaProdutos();
    carregaListaMateriais();
  }, []);

  useEffect(() => {
    if (orcamentoMateriais.length > 0 && orcamentos.id) {
      const listaAlterada = orcamentoMateriais.filter(
        element => element.listaMateriaisAlterada === true,
      );

      if (listaAlterada.length > 0 || orcamentos.listaAlterada === true) {
        setExibeBadge(true);
      }
    }
  }, [orcamentoMateriais, orcamentos]);

  useEffect(() => {
    if (deletingMaterial) {
      toast.loading(`Excluindo item da configuração ${orcamentoId}...`, {
        position: 'top-right',
      });
      return;
    }

    toast.dismiss();
  }, [deletingMaterial]);

  useEffect(() => {
    getTiposExclusao();
  }, []);

  async function handleAdicionarItensKit() {
    const materialSelecionado = orcamentoMateriais.find(
      item => item.excluirMaterial === true,
    );
    if (materialSelecionado) {
      const materialComposicao = orcamentoKits.find(
        k => k.orcamentoMaterialId === materialSelecionado.id,
      )?.composicao;
      if (materialComposicao && materialComposicao.length > 0) {
        setKitSelecionado(materialSelecionado);

        const materialComposicaoSalvar = materialComposicao.map(item => ({
          ...item,
          selecionado: item.id !== null,
          // quantidadeEditavel: item.quantidadeCalculada,
          quantidadeEditavel: item.quantidade ?? item.quantidadeCalculada,
          disabled: item.id === null,
        }));

        setItensComposicao(materialComposicaoSalvar);
        setModalAdicionarItens(true);
      }
    }
  }

  const handleQuantidadeChange = (itemIndex: number, newValue: number) => {
    setItensComposicao(prev =>
      prev.map((item, index) =>
        index === itemIndex ? { ...item, quantidadeEditavel: newValue } : item,
      ),
    );
  };

  const handleSelectionChange = (itemIndex: number, selecionado: boolean) => {
    setItensComposicao(prev =>
      prev.map((item, index) =>
        index === itemIndex ? { ...item, selecionado } : item,
      ),
    );
  };

  const buscaCodigoMaterial = (materialId: number | null) => {
    if (!materialId) return '';
    const material = listaTodosMateriais.find(m => m.id === materialId);
    // return material?.codigoSap || material?.diteCodigo || '';
    // Ajuste SAP
    return material?.diteCodigo || '';
  };

  async function handleAdicionarItensConfirmar() {
    try {
      Swal.fire({
        title: 'Salvando itens do kit...',
        icon: 'info',
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      const itensAdicionar = itensComposicao.filter(
        item => item.selecionado === true,
      );

      const response = await api.post('/orcamento/versao/adicionar-itens-kit', {
        materialDelete: kitSelecionado,
        materiaisInsert: itensAdicionar,
        orcamentoParteId: kitSelecionado?.orcamentoParteId,
      });

      const response2 = await api.post(
        '/orcamento/verifica-material-titulo-sequencia',
        {
          orcamentoId,
        },
      );

      Swal.fire({
        title:
          'Itens do kit salvos com sucesso! Atualizando lista de materiais. Por favor, aguarde...',
        icon: 'success',
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      setModalAdicionarItens(false);

      // await carregaOrcamentoKits(true);
      await carregaOrcamentoMateriais();
      await carregaOrcamentoKits(exibeKit);
    } catch (error) {
      toast.error('Erro ao adicionar itens do kit');
      console.error(error);
    }
  }

  async function handleDeletePropostaConfiguracaoMaterial() {
    const idsArray: number[] = [];

    let textoDescricao = '';
    const OrcamentoMateriais = orcamentoMateriais
      .filter(items => items.excluirMaterial === true)
      .map(materialItem_ => materialItem_) as OrcamentoMaterial[];

    for await (const item of OrcamentoMateriais) {
      textoDescricao = `${textoDescricao} + ${
        item.material.codigoSap ?? item.material.diteCodigo
      } - ${item.material.descricao} <br />`;
      idsArray.push(Number(item.id));
    }

    async function deletePropostaConfiguracaoMaterial(
      tipoExclusaoId: string,
      motivo: string,
    ) {
      try {
        setDeletingMaterial(true);

        await api.post('tipo-exclusao/salvar-excluir-materiais', {
          materiais: OrcamentoMateriais,
          tipoExclusao: tipoExclusaoId,
          orcamentoId,
          motivo,
        });

        setDeletingMaterial(false);
        carregaOrcamentoMateriais();
        carregaOrcamento();
      } finally {
        setDeletingMaterial(false);
      }
    }

    async function openModal() {
      const wrapper = document.createElement('div');

      Swal.fire({
        title: `Excluir item da configuração ${orcamentoId}?`,
        html: wrapper,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Sim, excluir`,
        confirmButtonColor: '#d33',
        cancelButtonText: `Não`,
        preConfirm: () => {
          const motivoInput = document.querySelector(
            '#motivo-input',
          ) as HTMLInputElement;
          const selectedTipo = document.querySelector(
            '#tipos_exclusao',
          ) as HTMLSelectElement;

          const motivo = motivoInput?.value;
          const tipo = selectedTipo?.value;

          if (!tipo || tipo.trim() === '') {
            Swal.showValidationMessage('Selecione um tipo de exclusão válido.');
            return false;
          }

          return { motivo, tipo };
        },
      }).then(result => {
        if (result.isConfirmed && result.value) {
          const { motivo, tipo } = result.value;
          deletePropostaConfiguracaoMaterial(tipo, motivo);
        }
      });

      const selectOptions = tiposExclusao
        .filter((tipo: any) => tipo.indicTipoExclusao)
        .map((tipo: any) => ({
          value: tipo.id,
          name: tipo.descricao,
        }));

      ReactDOM.render(
        <div>
          <strong>Selecione o motivo da exclusão*:</strong>
          <InputSelect id="tipos_exclusao" options={selectOptions} />
          <br />
          <strong>Complemento da exclusão do material:</strong>
          <input
            id="motivo-input"
            className="swal2-input"
            placeholder="Complemento da exclusão"
          />
        </div>,
        wrapper,
      );
    }

    openModal();
  }

  function handleSetRegraItemValue(
    materialItem: OrcamentoMaterial,
    attrName: string,
    value: string | number | boolean | null,
  ) {
    setOrcamentoMateriais(
      orcamentoMateriais.map(materialItem_ =>
        materialItem_.id === materialItem.id
          ? { ...materialItem_, [attrName]: value, regraAlterada: true }
          : materialItem_,
      ),
    );
  }

  function handleChangeAtivo(
    materialItem: OrcamentoMaterial,
    event: ChangeEvent<HTMLInputElement>,
  ) {
    const { checked } = event.target;
    const value = !!checked;
    handleSetRegraItemValue(materialItem, 'excluirMaterial', value);
  }

  function retornaOrigem(orcamentoMaterial: OrcamentoMaterial) {
    const { criadoManualmente, importacaoMaterialId, importacaoMaterial } =
      orcamentoMaterial;

    const mostrarImportado =
      criadoManualmente !== undefined &&
      criadoManualmente === true &&
      importacaoMaterialId !== null;

    const mostrarCriadoManualmente =
      criadoManualmente !== undefined && criadoManualmente === true;

    if (mostrarImportado) {
      return 'I';
    }

    if (mostrarCriadoManualmente) {
      return 'M';
    }

    return 'A';
  }

  function handleSelecionarItemDomsge(itemDomsge: ItemDomsge | null) {
    setItemDomsgeSelecionado(itemDomsge);
  }

  function handleExportToSheet() {
    const todosMateriais = [...materiaisAvulsosPlanilha, ...orcamentoMateriais];

    const dadosPlanilha = todosMateriais
      .filter(x => x.orcamentoMaterialId === null)
      .map(orcamentoMaterial => {
        const { material, regraAplicacao, quantidade } = orcamentoMaterial;
        const { diteCodigo, descricao } = material;
        return {
          Código: diteCodigo,
          Descrição: descricao,
          Aplicação: regraAplicacao,
          Quantidade: quantidade,
          Origem: retornaOrigem(orcamentoMaterial),
        };
      });
    const nomeArquivo = `Materiais - Configuração ${orcamentoId}`;
    exportToSheet(dadosPlanilha, nomeArquivo);
  }

  function renderMateriais() {
    if (!orcamentoMateriais.length) {
      return <></>;
    }

    function renderLinhaMaterial(
      orcamentoMaterial: OrcamentoMaterial,
      index: number,
      isSubItem = false,
    ) {
      const orcamentoKit = orcamentoKits.find(
        item => item.orcamentoMaterialId === orcamentoMaterial?.id,
      );

      const isMaterialAvulso = orcamentoKit?.criadoManualmente;

      const ciclo = orcamentoKit?.cicloVidaStatus;

      const posicaoEsquematica = orcamentoKit?.posicaoEsquematica;

      const atividade = orcamentoMaterial?.produtoAtividade
        ? traduzirProdutoAtividade(orcamentoMaterial.produtoAtividade, true)
        : '';

      const atividadeSeq = orcamentoKit?.sequenciaAtividade;

      const agrupador = orcamentoKit?.agrupador;

      const tipoItem = orcamentoKit?.tipoItem;

      const materialImportado = orcamentoKit?.materialImportado;

      const nomeArquivo = orcamentoKit?.nomeArquivo;

      const custoTotal =
        orcamentoKit?.custoTotal !== null
          ? formatCurrency(arredondaDecimais(orcamentoKit?.custoTotal))
          : '';

      return (
        <MaterialItemRow
          key={`${orcamentoMaterial.id}_${index}`}
          isSubItem={isSubItem}
        >
          <td className="text-center">{atividade ?? ''}</td>
          <td className="text-center">{atividadeSeq ?? ''}</td>
          <td className="text-center">{agrupador ?? ''}</td>
          <td className="text-center">{posicaoEsquematica ?? ''}</td>
          <td className="text-center">
            {buscaCodigoMaterial(orcamentoMaterial?.material?.id ?? 0)}
          </td>
          <td
            style={{
              whiteSpace: 'normal',
              wordBreak: 'break-word',
            }}
          >
            {orcamentoMaterial.material.descricao}
            {isMaterialAvulso && !materialImportado && (
              <span title="Material adicionado manualmente na configuração">
                <Badge color="success" className="ml-2">
                  M
                </Badge>
              </span>
            )}
            {materialImportado && (
              <span title={nomeArquivo}>
                <Badge
                  style={{ backgroundColor: '#FFD700', color: '#000' }}
                  className="ml-2"
                >
                  I
                </Badge>
              </span>
            )}
          </td>
          <td className="text-center">
            {arredondaDecimais(orcamentoMaterial.quantidade, 3) ?? ''}
          </td>
          <td className="text-center" hidden={!acessoLimitadoCusto.temAcesso}>
            {custoTotal}
          </td>
          <td className="text-center">{tipoItem}</td>
          <td>{orcamentoMaterial.regraAplicacao}</td>
          <td className="text-center">{ciclo}</td>
          <td className="text-center">
            {buscaCodigoMaterial(orcamentoMaterial.materialKitId || null)}
          </td>
          <td className="text-center">
            <Checkbox
              checked={orcamentoMaterial.excluirMaterial}
              onChange={(e: any) => {
                handleChangeAtivo(orcamentoMaterial, e);
              }}
              color="primary"
            />
          </td>
        </MaterialItemRow>
      );
    }

    function renderComposicaoKit(materialPai: OrcamentoMaterial) {
      const composicao = orcamentoKits.find(
        item => item.diteCodigo === materialPai?.material?.diteCodigo,
      )?.composicao;

      if (!composicao || !exibeKit) return null;

      return composicao.map((item, index) => (
        <SubItemRow key={`comp_${index}`}>
          <td className="text-center">{item.atividade ?? ''}</td>
          <td className="text-center">{item.sequenciaAtividade ?? ''}</td>
          <td className="text-center">{item.agrupador ?? ''}</td>
          <td className="text-center">{item.posicaoEsquematica ?? ''}</td>
          <td className="text-center">{item.diteCodigo}</td>
          <td style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
            {item.descricao}
          </td>
          <td className="text-center">
            {arredondaDecimais(item.quantidade, 3) ||
              arredondaDecimais(item.quantidadeCalculada, 3)}
          </td>
          <td className="text-center">{item.tipoItem}</td>
          <td>{item.aplicacao}</td>
          <td className="text-center">{item.cicloVidaStatus}</td>
          <td />
          <td />
        </SubItemRow>
      ));
    }

    function renderCabecalhoGrupo(titulo: string, tag: any, isAvulsos = false) {
      const materiaisUsar = isAvulsos
        ? orcamentoMateriais.filter(item => item.criadoManualmente === true)
        : orcamentoMateriais.filter((item2: any) =>
            tag?.agrupadorTag?.find(
              (items: { regraAgrupador: { nome: string } }) =>
                items.regraAgrupador.nome === item2.regraAplicacao,
            ),
          );

      const allChecked = !(
        materiaisUsar.filter(item => item.excluirMaterial === false).length > 0
      );

      return (
        <>
          <GroupHeaderRow>
            <th className="text-center">
              <span>{titulo}</span>
            </th>
            <th colSpan={12} />
          </GroupHeaderRow>
          <GroupHeaderRow>
            <th className="text-center">Ativ </th>
            <th className="text-center">Seq </th>
            <th className="text-center">Grupo</th>
            <th className="text-center">Ordem</th>
            <th className="text-center">Cod.</th>
            <th className="text-center">Descrição</th>
            <th className="text-center">Qtd.</th>
            <th className="text-center" hidden={!acessoLimitadoCusto.temAcesso}>
              Custo
            </th>
            <th className="text-center">Un.</th>
            <th className="text-center">Aplicação</th>
            <th className="text-center">Status</th>
            <th className="text-center">Kit Origem</th>
            <th>
              <div className="text-center">
                <Checkbox
                  checked={allChecked}
                  onChange={(e: any) => {
                    if (isAvulsos) {
                      setOrcamentoMateriais(prevMateriais =>
                        prevMateriais.map(material =>
                          material.criadoManualmente === true
                            ? {
                                ...material,
                                excluirMaterial: e.target.checked,
                                regraAlterada: true,
                              }
                            : material,
                        ),
                      );
                    } else {
                      const listaAlterar = orcamentoMateriais.filter(
                        (item2: any) =>
                          tag?.agrupadorTag?.find(
                            (items: { regraAgrupador: { nome: string } }) =>
                              items.regraAgrupador.nome ===
                              item2.regraAplicacao,
                          ),
                      );

                      setOrcamentoMateriais(prevMateriais =>
                        prevMateriais.map(material => {
                          const isInGroup = listaAlterar.some(
                            groupItem => groupItem.id === material.id,
                          );
                          return isInGroup
                            ? {
                                ...material,
                                excluirMaterial: e.target.checked,
                                regraAlterada: true,
                              }
                            : material;
                        }),
                      );
                    }
                  }}
                  color="primary"
                  title="Selecionar todos"
                />
              </div>
            </th>
          </GroupHeaderRow>
        </>
      );
    }

    function renderTabelaPorGrupo() {
      return (
        <>
          {orcamentoMateriais.filter(item => item.criadoManualmente === true)
            .length > 0 && (
            <>
              <thead>
                {renderCabecalhoGrupo(
                  'AVULSOS',
                  {
                    id: null,
                    codigo: null,
                    descricao: 'Materiais Avulsos',
                    agrupadorTag: [{ regraAgrupador: {} }],
                  },
                  true,
                )}
              </thead>
              <tbody>
                {orcamentoMateriais
                  .filter(item => item.criadoManualmente === true)
                  .map((item, index) => (
                    <Fragment key={item.id}>
                      {renderLinhaMaterial(item, index)}
                      {renderComposicaoKit(item)}
                    </Fragment>
                  ))}
              </tbody>
            </>
          )}

          {tags
            .filter(item =>
              item?.agrupadorTag?.some(
                (items: { regraAgrupador: { nome: string } }) =>
                  orcamentoMateriais.find(
                    (item2: any) =>
                      item2.regraAplicacao === items.regraAgrupador.nome,
                  ),
              ),
            )
            ?.map(tag => {
              const textoDesc = `${String(tag?.codigo)}) ${String(
                tag?.descricao,
              )}`;
              return (
                <Fragment key={tag.id}>
                  {renderCabecalhoGrupo(textoDesc, tag)}
                  {orcamentoMateriais
                    .filter((item2: any) =>
                      tag?.agrupadorTag?.find(
                        items =>
                          items.regraAgrupador.nome === item2.regraAplicacao,
                      ),
                    )
                    .map((item, index) => (
                      <Fragment key={item.id}>
                        {renderLinhaMaterial(item, index)}
                        {renderComposicaoKit(item)}
                      </Fragment>
                    ))}
                </Fragment>
              );
            })}
        </>
      );
    }

    function renderTabelaPorAtividade() {
      const groupedByAtividade = orcamentoMateriais.reduce((acc, item) => {
        const atividade = item.produtoAtividadeId || 0;
        if (!acc[atividade]) {
          acc[atividade] = [];
        }
        acc[atividade].push(item);
        return acc;
      }, {} as Record<number, OrcamentoMaterial[]>);

      return (
        <>
          {Object.entries(groupedByAtividade).map(([atividade, items]) => {
            const allChecked = items.every(item => item.excluirMaterial);

            const ativUsar = items[0].produtoAtividade;

            const groupedBySequencia = items.reduce((acc, item) => {
              const sequencia = item?.sequenciaAtividade || 0;

              if (!acc[sequencia]) {
                acc[sequencia] = [];
              }
              acc[sequencia].push(item);
              return acc;
            }, {} as Record<number, OrcamentoMaterial[]>);

            const sortedSequencias = Object.keys(groupedBySequencia)
              .map(Number)
              .sort((a, b) => a - b);

            return (
              <Fragment key={atividade}>
                <thead>
                  <GroupHeaderRow>
                    <th className="text-center">
                      {ativUsar ? traduzirProdutoAtividade(ativUsar) : ''}
                    </th>
                    <th colSpan={12} />
                  </GroupHeaderRow>
                  <GroupHeaderRow>
                    <th className="text-center">Ativ</th>
                    <th className="text-center">Seq</th>
                    <th className="text-center">Grupo</th>
                    <th className="text-center">Ordem</th>
                    <th className="text-center">Cod.</th>
                    <th className="text-center">Descrição</th>
                    <th className="text-center">Qtd.</th>
                    <th
                      className="text-center"
                      hidden={!acessoLimitadoCusto.temAcesso}
                    >
                      Custo
                    </th>
                    <th className="text-center">Un.</th>
                    <th className="text-center">Aplicação</th>
                    <th className="text-center">Status</th>
                    <th className="text-center">Kit Origem</th>
                    <th>
                      <div className="text-center">
                        <Checkbox
                          checked={allChecked}
                          onChange={e => {
                            const { checked } = e.target;
                            setOrcamentoMateriais(prevMateriais =>
                              prevMateriais.map(material => {
                                if (
                                  items.some(item => item.id === material.id)
                                ) {
                                  return {
                                    ...material,
                                    excluirMaterial: checked,
                                    regraAlterada: true,
                                  };
                                }
                                return material;
                              }),
                            );
                          }}
                          color="primary"
                          title="Selecionar todos"
                        />
                      </div>
                    </th>
                  </GroupHeaderRow>
                </thead>

                <tbody>
                  {sortedSequencias.map(sequencia => {
                    const sequenciaItems = groupedBySequencia[sequencia];
                    const tituloSequencia =
                      sequenciaItems[0]?.tituloSequencia || '';

                    const isEditing =
                      editingSequencia?.atividade === Number(atividade) &&
                      editingSequencia?.sequencia === sequencia;

                    return (
                      <Fragment key={sequencia}>
                        {/* Sequencia separator row - acts as a line break */}
                        {sortedSequencias.length > 0 && (
                          <tr style={{ backgroundColor: '#f8f9fa' }}>
                            <td
                              colSpan={13}
                              style={{
                                padding: '8px 10px',
                                fontWeight: 'bold',
                                fontStyle: 'italic',
                                borderBottom: '2px solid #dee2e6',
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '8px',
                                }}
                              >
                                <span>Sequência {sequencia}</span>

                                {isEditing ? (
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '8px',
                                    }}
                                  >
                                    <Input
                                      type="text"
                                      value={tempTituloSequencia}
                                      onChange={e =>
                                        setTempTituloSequencia(e.target.value)
                                      }
                                      onKeyPress={e => {
                                        if (e.key === 'Enter') {
                                          handleSaveSequenciaTitle();
                                        }
                                      }}
                                      style={{
                                        padding: '2px 6px',
                                        fontSize: '14px',
                                        height: '28px',
                                      }}
                                      autoFocus
                                    />
                                    <Button
                                      color="success"
                                      size="sm"
                                      onClick={handleSaveSequenciaTitle}
                                      style={{
                                        padding: '2px 8px',
                                        fontSize: '12px',
                                      }}
                                    >
                                      ✓
                                    </Button>
                                    <Button
                                      color="danger"
                                      size="sm"
                                      onClick={handleCancelEditSequencia}
                                      style={{
                                        padding: '2px 8px',
                                        fontSize: '12px',
                                      }}
                                    >
                                      ✕
                                    </Button>
                                  </div>
                                ) : (
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '8px',
                                    }}
                                  >
                                    {tituloSequencia && (
                                      <>
                                        <span style={{ whiteSpace: 'pre' }}>
                                          {' '}
                                          -{' '}
                                        </span>
                                        <span>{tituloSequencia}</span>
                                      </>
                                    )}
                                    <Button
                                      color="link"
                                      size="sm"
                                      onClick={() => {
                                        console.log(
                                          'sortedSequencias',
                                          sortedSequencias,
                                        );
                                        console.log('sequencia:', sequencia);

                                        handleStartEditSequencia(
                                          Number(atividade),
                                          sequencia,
                                          tituloSequencia,
                                        );
                                      }}
                                      style={{
                                        padding: '0 4px',
                                        fontSize: '12px',
                                        color: '#6c757d',
                                      }}
                                      title="Editar título da sequência"
                                    >
                                      ✏️
                                    </Button>
                                  </div>
                                )}
                              </div>
                            </td>
                          </tr>
                        )}

                        {/* Itens da sequencia */}
                        {sequenciaItems.map((item, index) => (
                          <Fragment key={item.id}>
                            {renderLinhaMaterial(item, index)}
                            {renderComposicaoKit(item)}
                          </Fragment>
                        ))}
                      </Fragment>
                    );
                  })}
                </tbody>
              </Fragment>
            );
          })}
        </>
      );
    }

    async function handleCarregarComposicao() {
      // Swal.fire({
      //   icon: 'info',
      //   text: `Buscando composição...`,
      //   allowOutsideClick: false,
      //   showConfirmButton: false,
      // });

      // if (!exibeKit) await carregaOrcamentoKits();

      if (!exibeKit) {
        Swal.fire({
          icon: 'info',
          text: `Buscando composição...`,
          allowOutsideClick: false,
          showConfirmButton: false,
        });

        await carregaOrcamentoKits(true);
      }

      setExibeKit(!exibeKit);
      // Swal.close();
    }

    return (
      <MaterialContainer>
        <Row hidden>
          <Col>
            <span title="Lista de materiais alterada!">
              <Badge color="warning" className="ml-2">
                <span className="alert-icon">
                  <FaExclamationTriangle />
                </span>
                A lista de materiais foi alterada manualmente!
              </Badge>
            </span>
          </Col>
        </Row>
        <Row className="ml-1">
          <Col xs="8" style={{ paddingLeft: '2rem', paddingTop: '1rem' }}>
            <h4 className="mb--1">Lista de materiais</h4>
            <small className="text-muted"> </small>
          </Col>

          <ButtonsRightCol sm="1">
            <Button
              className="btn-icon btn-2"
              color="primary"
              type="button"
              outline
              size="sm"
              onClick={() => {
                handleCarregarComposicao();
              }}
            >
              {exibeKit ? 'Esconder Kits' : 'Mostrar Kits'}
            </Button>{' '}
          </ButtonsRightCol>
          <ButtonsRightCol sm="2">
            <Input
              type="select"
              id="agrupadorSelect"
              value={agrupadorSelecionado}
              onChange={e => {
                setAgrupadorSelecionado(e.target.value);
                setOrcamentoMateriais(prevMateriais =>
                  prevMateriais.map(material => ({
                    ...material,
                    excluirMaterial: false,
                  })),
                );
              }}
              className="form-control"
              style={{ marginTop: '0.5rem' }}
            >
              <option value="Grupo">Agrupar por Grupo</option>
              <option value="Atividade">Agrupar por Atividade</option>
            </Input>
          </ButtonsRightCol>
        </Row>

        <Row className="ml-2">
          <Col>
            <MaterialListContainer>
              <Table responsive style={{ width: '100%' }}>
                {agrupadorSelecionado === 'Grupo'
                  ? renderTabelaPorGrupo()
                  : renderTabelaPorAtividade()}
              </Table>
            </MaterialListContainer>
          </Col>
        </Row>
      </MaterialContainer>
    );
  }

  return (
    <>
      <UserSmallHeader />
      <Container className="mt-2" fluid>
        <Row>
          <Col sm="12">
            <div className=" float-right  mr-2">
              <Button
                size="sm"
                className="btn-icon btn-2  float-right"
                style={{ backgroundColor: '#1a8c5b', width: '200px' }}
                color="success"
                type="button"
                onClick={handleExportToSheet}
              >
                <FaFileExcel />
                <span className="btn-inner--text">Exportar planilha</span>
              </Button>
            </div>
          </Col>
        </Row>
        <Row className="mt-3" style={{ width: '100%' }}>
          <Col sm="12">
            <ConfiguracaoMaterialAvulso
              setMateriaisAvulsosPlanilha={setMateriaisAvulsosPlanilha}
              // recarregarLista={recarregarLista}
              setDeveRecarregarComp={setDeveRecarregarComp}
            />
          </Col>
        </Row>
        <Row className="mt-3" style={{ width: '100%' }}>
          <Col sm="12">
            {kitCarregado && matCarregado && renderMateriais()}
            <div
              style={{
                position: 'fixed',
                bottom: '20px',
                right: '20px',
                display: 'flex',
                gap: '10px',
                zIndex: 1000,
              }}
            >
              <FloatingButton
                hidden={
                  !orcamentoMateriais?.filter(
                    item =>
                      item.excluirMaterial === true &&
                      orcamentoKits.some(
                        kit =>
                          kit.diteCodigo === item.material.diteCodigo &&
                          kit.composicao?.length > 0,
                      ),
                  ).length
                }
                className="hide-on-print"
                color="primary"
                onClick={handleAdicionarItensKit}
                disabled={
                  orcamentoMateriais?.filter(
                    item => item.excluirMaterial === true,
                  ).length !== 1
                }
                title={
                  orcamentoMateriais?.filter(
                    item => item.excluirMaterial === true,
                  ).length !== 1
                    ? 'Selecione somente um kit'
                    : 'Adicionar itens do Kit'
                }
                style={{
                  position: 'relative',
                  bottom: 'auto',
                  right: 'auto',
                }}
              >
                <FaPlus style={{ color: 'white' }} />
              </FloatingButton>
              <FloatingButton
                hidden={
                  !orcamentoMateriais?.filter(
                    item => item.excluirMaterial === true,
                  ).length
                }
                className="hide-on-print"
                color="secondary"
                onClick={handleDeletePropostaConfiguracaoMaterial}
                style={{ position: 'relative', bottom: 'auto', right: 'auto' }}
              >
                <FaTrash style={{ color: 'white' }} />
              </FloatingButton>
            </div>
          </Col>
        </Row>
        <Modal
          isOpen={modalAdicionarItens}
          toggle={() => setModalAdicionarItens(false)}
          size="lg"
          className="modal-dialog-centered"
        >
          <ModalHeader toggle={() => setModalAdicionarItens(false)}>
            Salvar Itens do Kit: {kitSelecionado?.material.descricao}
          </ModalHeader>
          <ModalBody style={{ maxHeight: '60vh', overflowY: 'auto' }}>
            <Row className="align-items-center">
              <Col sm="7">
                <AutocompleteItemDomsge
                  key={resetKey}
                  hideTitle
                  handleSelecionarItemDomsge={handleSelecionarItemDomsge}
                  noAutoFocus
                  emprCodigo={codEmpresa}
                  compact
                />
              </Col>
              <Col sm="2">
                <Input
                  type="number"
                  id="quantidade-input"
                  min={1}
                  step={1}
                  value={quantidadeNovoItem}
                  onChange={e =>
                    setQuantidadeNovoItem(parseInt(e.target.value, 10) || 1)
                  }
                />
              </Col>
              <Col sm="3" className="d-flex align-items-end">
                {' '}
                <Button
                  className="btn-icon"
                  color="primary"
                  type="button"
                  onClick={addItemComposicao}
                  disabled={!itemDomsgeSelecionado}
                >
                  <FaPlusCircle />
                </Button>
              </Col>
            </Row>
            <div className="table-responsive">
              <table className="table table-sm table-hover align-middle w-100">
                <thead className="thead-light">
                  <tr>
                    <th
                      style={{
                        width: '10%',
                        textAlign: 'center',
                        verticalAlign: 'middle',
                      }}
                    >
                      <Checkbox
                        checked={itensComposicao.every(
                          item => item.selecionado,
                        )}
                        onChange={e => {
                          const allSelected = itensComposicao.every(
                            item => item.selecionado,
                          );
                          setItensComposicao(prev =>
                            prev.map(item => ({
                              ...item,
                              selecionado: !allSelected,
                            })),
                          );
                        }}
                        color="primary"
                      />
                    </th>
                    <th
                      style={{
                        textAlign: 'center',
                        width: '20%',
                        verticalAlign: 'middle',
                      }}
                    >
                      Código
                    </th>
                    <th
                      style={{
                        textAlign: 'center',
                        width: '40%',
                        verticalAlign: 'middle',
                      }}
                    >
                      Descrição
                    </th>
                    <th
                      style={{
                        textAlign: 'center',
                        width: '30%',
                        verticalAlign: 'middle',
                      }}
                    >
                      Quantidade
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {itensComposicao.map((item, index) => (
                    <tr
                      key={index}
                      className={`${item.selecionado ? 'table-active' : ''} ${
                        item.id === null ? 'table-secondary' : ''
                      }`}
                      title={
                        item.id === null ? 'Material não existe no portal' : ''
                      }
                    >
                      <td
                        style={{ textAlign: 'center', verticalAlign: 'middle' }}
                      >
                        <Checkbox
                          checked={item.selecionado}
                          onChange={e =>
                            handleSelectionChange(index, e.target.checked)
                          }
                          color="primary"
                          disabled={item.id === null}
                        />
                      </td>
                      <td style={{ verticalAlign: 'middle' }}>
                        <span className="font-weight-bold text-primary">
                          {buscaCodigoMaterial(item.id)}
                        </span>
                      </td>
                      <td style={{ verticalAlign: 'middle' }}>
                        <span className="text-sm">{item.descricao}</span>
                      </td>
                      <td style={{ verticalAlign: 'middle' }}>
                        <Input
                          type="number"
                          value={item.quantidadeEditavel}
                          onChange={e =>
                            handleQuantidadeChange(
                              index,
                              parseFloat(e.target.value) || 0,
                            )
                          }
                          min="1"
                          step="1"
                          disabled={!item.selecionado || item.id === null}
                          className="text-right w-75"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="danger"
              onClick={() => setModalAdicionarItens(false)}
              className="min-width-100"
              outline
            >
              Cancelar
            </Button>
            <Button
              color="primary"
              onClick={handleAdicionarItensConfirmar}
              disabled={
                itensComposicao.filter(item => item.selecionado).length === 0
              }
              className="min-width-100"
            >
              Salvar
            </Button>
          </ModalFooter>
        </Modal>
      </Container>
    </>
  );
};

export default ConfiguracaoMateriais;
